import { render, staticRenderFns } from "./Enviar_medallas.vue?vue&type=template&id=9b288558&scoped=true"
import script from "./Enviar_medallas.vue?vue&type=script&lang=js"
export * from "./Enviar_medallas.vue?vue&type=script&lang=js"
import style0 from "./Enviar_medallas.vue?vue&type=style&index=0&id=9b288558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b288558",
  null
  
)

export default component.exports